export default "__VITE_ASSET__LnSpZ6C1__"